<section class="mr-auto flex flex-col gap-4 p-6">
  <h4 class="text-paragraph-med text-primary-900">
    {{ "calculator.selectCalculationMode" | transloco }}
  </h4>

  <app-category-selector
    [categoryList]="categoryList"
    [(selectedValue)]="calculationMode"
    type="list"
  />
</section>
